import { render, staticRenderFns } from "./user-change-password.vue?vue&type=template&id=5361a79a&scoped=true"
import script from "./user-change-password.vue?vue&type=script&scoped=true&lang=js"
export * from "./user-change-password.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./user-change-password.vue?vue&type=style&index=0&id=5361a79a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5361a79a",
  null
  
)

export default component.exports